import { createContext } from 'react';
import { UserType } from '../hooks/queries';

export const LoginContext = createContext<UserType | null>(null);
